import Image from 'next/image';

import {
  reviewCard,
  reviewCardContent,
  reviewCardImage,
  reviewCardInfo,
  reviewCardName,
} from '@/app/[locale]/(new)/(public)/projects/[slug]/_page.css';
import parseHtml from '@/lib/html-parse';

export interface ReviewCardProps {
  pictureUrl: string;
  fullname: string;
  company: { name: string; position: string };
  content: string;
}

export function ReviewCard({
  pictureUrl,
  fullname,
  company,
  content,
}: ReviewCardProps) {
  return (
    <section className={reviewCard}>
      <Image
        className={reviewCardImage}
        width={48}
        height={48}
        src={pictureUrl}
        alt={fullname}
      />
      <span className={reviewCardName}>{fullname}</span>
      <span className={reviewCardInfo}>
        {company.position}, {company.name}
      </span>
      <section className={reviewCardContent}>{parseHtml(content)}</section>
    </section>
  );
}
